(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bulk_options"] && !Shopify.designMode) return;
  try {
    class BulkOptions extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.selectedOption = null;
      this.quantityInput = null;

      this.regularPrice = this.dataset.price
      this.salePrice = this.dataset.saleprice || null
      this.badgePrice = this.salePrice ? this.salePrice - this.regularPrice : null
    }

    connectedCallback() {


      this.buttons.forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });




      setTimeout(() => {
        this.querySelector('button[data-selected="true"]').click()

        this.quantityChangeButtons()

  

      },1000)


    document.addEventListener('drawer:afterShow', function(event) {
    
      if (event.target.matches('cart-drawer')) {
        this.querySelector('button[data-selected="true"]').click()
      }
    });

   


      
    }

    onButtonClick(event) {
      const selectedButton = event.currentTarget;
      this.selectedOption = selectedButton.dataset.value;

      this.buttons.forEach(button => {
        button.classList.remove('selected');
      });

      selectedButton.classList.add('selected');
      this.updateQuantity();
    }

    updateQuantity() {
      const getQumatityInput = this.closest('product-info').querySelector('input[name="quantity"]')
      if (!getQumatityInput) {
        return;
      }

      let quantity;
      if (this.selectedOption === 'base-car-unit') {
        quantity = 1;
      } else {
        quantity = parseInt(this.selectedOption.split('-')[0], 10);
      }

      if (!isNaN(quantity)) {
        getQumatityInput.value = quantity;
        this.changePrice(getQumatityInput.value)
        getQumatityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }


    quantityChangeButtons(){
      const quantity = this.closest('product-info').querySelector('input[name="quantity"]')

      quantity.addEventListener('change', (q) => {

        this.buttons.forEach(button => {
   
           button.classList.remove('selected');
          if(button.dataset.value.replace('-',',').split(',').includes(q.target.value)){
            button.classList.add('selected');
          }
        });

         this.changePrice(q.target.value)

      })

      
      
    }

   changePrice(q){
    
      const priceRegular = this.closest('product-info').querySelector('.product__price .price .price__regular')
      const priceSale = this.closest('product-info').querySelector('.product__price .price .price__sale')
      const priceBadge = this.closest('product-info').querySelector('.product__price .price-sale-badge')

      function formatPrice(price) {
        return '$'+(price / 100).toFixed(2);
      }
      
      if(priceRegular){
        priceRegular.innerHTML = formatPrice(Number(this.regularPrice * q))
      }
      if(priceSale){
        priceSale.innerHTML = formatPrice(Number(this.salePrice * q))
      }
      if(priceBadge){
        priceBadge.innerHTML = 'Sale ' + formatPrice(Number(this.badgePrice * q))
      }
    }


 

  }

  if (!customElements.get('bulk-options')) {
    customElements.define('bulk-options', BulkOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
